"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.langs = void 0;
// names for permission trees and branches
exports.langs = {
    en: {
        REQUEST_SCHEDULE: "Request & Schedule",
        SHIFTS_DETAILS: "Shifts",
        SHIFTS_HISTORY: "History",
        SHIFTS_PAY: "Pay Rates",
        SHIFTS_COST: "Charges Rates",
        SHIFTS_PUBLISH: "Publish draft shifts",
        SHIFTS_CANCEL: "Cancel shifts",
        OVERRIDE_NONCOMPLIANCE: "Override non-compliance",
        MY_STAFF: "My Staff",
        MEMBERS: "Members",
        MEMBERS_BANK: "Bank Details",
        MEMBERS_STATE: "Members State",
        MEMBERS_PAY: "Pay",
        MEMBERS_HISTORY: "History",
        MEMBER_COMPLIANCE: "Compliance",
        REPORTS_MY_STAFF: "Download staff & company data",
        PROVIDE_TIMESHEETs: "Provide & Timesheets",
        TIMESHEETS: "Timesheets",
        TIMESHEETS_APPROVAL: "Approve",
        TIMESHEETS_PRINT: "Print View",
        VIEW_BOOKINGS: "View/Open Bookings",
        PARTNER_INFORMATION: "Partner information",
        SETTINGS: "Settings",
        REPORTS_PAYROLL: "Payroll Reports",
        BRIEFING_TEMPLATES: "Briefing Templates",
        VENUES: "Venues",
        MEMBER_POOLS: "Pools",
        UNIFORM_TEMPLATES: "Uniform Templates",
        GENERAL_SETTINGS: "General settings",
    },
};
